export enum orderType {
	Refill = 1,
	Exchange = 2
}

export const Ordertype: any = {
	1: 'Refill',
	2: 'Exchange'
};

export enum OrderStatus {
	PENDING = 1,
	PASS = 2,
	ACCEPTED = 3,
	ONGOING = 4,
	CANCELLED_BY_DRIVER = 5,
	DELIVERED = 7,
	CANCELLED_BY_CUSTOMER = 8,
	CANCELLED_BY_ADMIN = 9,
	LEAKAGE = 10,
	CONFIRMED = 6
}

export const Orderstatus: any = {
	1: 'Pending',
	2: 'Pass',
	3: 'Accepted',
	4: 'Ongoing',
	5: 'Cancelled By Driver',
	7: 'Delivered',
	8: 'Cancelled By Customer',
	9: 'Cancelled By Admin',
	10: 'Leakage'
};

export const OrderstatusBG: any = {
	1: 'warning',
	2: 'secondary',
	3: 'success',
	4: 'info',
	5: 'danger',
	7: 'success',
	8: 'danger',
	9: 'danger',
	10: 'danger'
};

export enum PaymentMode {
	CASH_ON_DELIVERY = 1,
	ONLINE = 2
}

export enum PaymentStatusVendor {
	PAID = 1,
	UNPAID = 2
}

export const Paymentstatus: any = {
	1: 'Paid',
	2: 'Unpaid'
};

export const Paymentmode: any = {
	1: 'Cash',
	// 1: 'Cash On Delivery',
	2: 'Online'
};

export enum CancelPendingOrder {
	reason = 9
}

export enum DriverProfileStatus {
	Pending = 0,
	Approved = 1,
	Rejected = 2
}
export const DriverProfileStatusBadgeBG: any = {
	0: 'warning',
	1: 'success',
	2: 'danger'
};

export enum UserType {
	SUPERADMIN = 1,
	ADMIN = 2,
	CUSTOMER = 3,
	VENDOR = 4,
	DRIVER = 5
}

export const UserTypeLabel: any = {
	1: 'SUPERADMIN',
	2: 'ADMIN',
	3: 'CUSTOMER',
	4: 'VENDOR',
	5: 'DRIVER'
};

export enum LanguageType {
	EN = 1,
	AR = 2
}
export const VendorApprovalStatus: any = {
	0: 'Pending',
	1: 'Approved',
	2: 'Rejected'
};

// export const VendorChangeApprovalStatus: any = {
// 	0: 1,
// 	1: 2,
// 	2: 0
// };
